/**
 * Load Plugins
 * If you don't see a plugin below it might be autloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 */
require('foundation-sites');
require('jquery-match-height');
require('slick-carousel');
require('@fancyapps/fancybox');
import salvattore from 'salvattore';
import SmoothScroll from 'smooth-scroll';
var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);
var debouncedresize = require('./debouncedresize');
var footerPosition = require('./footer-position');
var megaMenu = require('./megamenu');
require('selection-sharer/dist/selection-sharer.css');
var Selection = require('selection-sharer');
var selection = new Selection('.box.post p');

import { WOW } from 'wowjs';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


/**
 *
 * Application script
 *
 */

$(function() {

    // init Foundation
    $(document).foundation();

    // Wowjs
    var wow = new WOW(
        {
            boxClass:     'wow',            // animated element css class (default is wow)
            animateClass: 'is-animating',   // animation css class (default is animated)
            offset:       100,                // distance to the element when triggering the animation (default is 0)
            mobile:       false,             // trigger animations on mobile devices (default is true)
            live:         false,             // act on asynchronously loaded content (default is true)
            callback:     function(box) {},
            scrollContainer: null // optional scroll container selector, otherwise use window
        }
    );
    $('.wow-wrapper').addClass('is-animating');
    wow.init();

    debouncedresize();

    if($('.HomePage').length > 0 && Foundation.MediaQuery.atLeast('medium')){
        var logScrollEvent = function (event) {
            if(window.location.hash == "#"+event.detail.anchor.id) {
                $('.home-menu a').removeClass("active");
                $('#' + event.detail.anchor.id + '-menu-item').addClass("active");
            }
        };
        document.addEventListener('scrollStop', logScrollEvent, false);
        window.addEventListener('scroll', function(e) {
            var closest = $(window).height();
            var closestSlide = null;
            $('.home-slides__slide').each(function(){
                var offset = $(this).offset().top + ($(this).height() / 2);
                var a = Math.abs($(document).scrollTop() - offset);
                if (a < closest) {
                    closestSlide = $(this);
                }
            });
            if($('#' + closestSlide.attr('id') + '-menu-item').hasClass("active")) {
            } else {
                $('.home-menu a').removeClass("active");
                $('#' + closestSlide.attr('id') + '-menu-item').addClass("active");
            }

        });

        //home page menu stuff
        var HomeScrollOptions = {
            easing: 'easeInCubic',
            updateURL: true,
            popstate: false
        };
        var HomeScrollLinks = new SmoothScroll('[data-scroll]', HomeScrollOptions);
    }

    // google analytics
    $('[data-ga-label]').each(function(){
        $(this).on('click', function() {
            var $trackingName = $(this).data('ga-label'),
            $tagName = $(this).prop("tagName"),
            $action = 'click';
            if($tagName=='input'){
                $action = 'submit';
            }
            ga('send', 'event', 'button', $action, $trackingName);
        });
    });

    $("input[name='EditableTextField_mailchimp']").each(function(){
        $(this).attr('checked', true);
    });

    function bannerInnerHeight() {
        $('.title-col .inner').css('height', 'auto');
        var bannerInner = $('.title-col .inner').outerHeight();
        $('.title-col .inner').css('height', bannerInner);
    }

    function homeBanner() {
        const homeSlides = $('.home-slides');
        const banner = $('.home-banner');
        const homeText = $('.home-text');
        const browserHeight = $(window).height();
        const topNavHeight = $('.toolbar').height();
        const sectorsHeight = $('.home-sectors').height();

        if (Foundation.MediaQuery.atLeast('xlarge')) {
            banner.css('height','100%');
            homeText.css('height', '100vh');
            banner.css('margin-top', 0);
            homeSlides.css('margin-top', 0);
        } else {
            var bannerHeight = browserHeight - (topNavHeight + sectorsHeight);
            //banner.css('height', bannerHeight);
            banner.css('margin-top', topNavHeight);
            //homeText.css('height', bannerHeight);
            homeSlides.css('margin-top', topNavHeight);
        }
    }

    // When browser is resized...
    $(window).on("debouncedresize", function( event ) {
        bannerInnerHeight();
        footerPosition();
        homeBanner();
    });

    bannerInnerHeight();
    footerPosition();
    megaMenu();
    homeBanner();

    // slick carousel
    if($('.slide-carousel').length > 0 || $('.grid-carousel').length > 0){
        $('.slide-carousel, .grid-carousel').not('.slick-initialized').slick({
            prevArrow: '<button class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            adaptiveHeight: true
        });
    }

    if($('.gallery-slider').length > 0 || $('.snippet-gallery').length > 0){
        $('.gallery-slider, .snippet-gallery').not('.slick-initialized').slick({
            prevArrow: '<button class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            adaptiveHeight: true,
            dots: true
        });
    }
});

// match those heights
var matchHeightOptions = {
    byRow: true
}
$('.mh').matchHeight(matchHeightOptions);
$('.mh-outer').matchHeight(matchHeightOptions);
$('.mh-wrapper').matchHeight(matchHeightOptions);

// $('.box').imagesLoaded(function() {
//     $(this).matchHeight(matchHeightOptions);
// });

// pagination
if ($('.pagination').length) {
    var paginate = function (url) {
        var param = '&ajax=1',
            ajaxUrl = (url.indexOf(param) === -1) ?
                       url + '&ajax=1' :
                       url,
            cleanUrl = url.replace(new RegExp(param+'$'),'');
        $.ajax(ajaxUrl)
            .done(function (response) {
                $('.paged-tiles .pagination').remove();
                // console.log(response);
                var responseArray = $(response);
                // console.log(responseArray);
                var results = responseArray.filter('.paged-tiles').find('.block-wrapper');
                results.each(function() {
                    $('.paged-tiles').append($(this));
                });
                $('.block-wrapper').foundation();
                var pagination = responseArray.filter('.paged-tiles').find('.pagination');
                $('.paged-tiles').append(pagination);
            })
            .fail (function (xhr) {
                alert('Error: ' + xhr.responseText);
            });
    };

    $('.paged-tiles').on('click','.pagination a', function (e) {
        e.preventDefault();
        paginate($(this).attr('href'));
    });
}

if ($('.pagination').length) {

    // var elem = document.querySelector('.blocks-posts');
    // var msnry = new Masonry( elem, {
    //     itemSelector: '.large-6',
    //     columnWidth: '.large-6',
    //     // percentPosition: true,
    //     // horizontalOrder: false,
    //     originTop: false,
    //     // gutter: 0
    // });

    $('.box').imagesLoaded(function() {
        // $('.box').matchHeight();
        // msnry.layout();
    });

    var paginateBlog = function (url) {
        // msnry.destroy();
        $('.more-btn').text("Loading...");

        // find and count all the boxes
        var totalPosts = $('.blog-section .blog-container').find(".box.post").length;
        var total = $('.blog-section .blog-container .blocks-posts').data("blog-count");
        total = total-1;

        $.ajax(url+"?ajax=1&start="+totalPosts)
            .done(function (response) {

                sessionStorage.scrollTop = document.body.scrollTop;
                // add new posts
                // $('.blog-section>.blog-container>.blocks-posts').append(response);
                
                $.each($(response).filter(".artcl"), function(){
                    $('.blog-section>.blog-container>.blocks-posts').find('.column:last-of-type').append($(this));
                });
                var updatedTotalPosts = $('.blog-section .blog-container').find(".box.post").length;
                
                if(totalPosts == updatedTotalPosts) {
                    $('.blog-section .pagination').remove();
                }

                // re fire foundation and match height
                $('.blocks-posts').foundation();
                $('.box').imagesLoaded(function() {
                    // $('.box').matchHeight();
                    $('.gallery-slider').not('.slick-initialized').slick({
                        prevArrow: '<button class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
                        nextArrow: '<button class="slick-next"><i class="fa fa-chevron-right"></i></button>',
                        adaptiveHeight: false,
                        dots: true
                    });
                    salvattore.rescanMediaQueries($('.blog-section>.blog-container>.blocks-posts'));
                });

                // changing the text...
                $('.more-btn').text("Load More");

                // scroll mate scroll
                var scroll = new SmoothScroll();
                var anchor = document.querySelector( '#bot' );
                var options = { speed: 600, easing: 'easeOutCubic', offset: 450, updateURL: false };
                scroll.animateScroll( anchor, anchor, options );

            })
            .fail (function (xhr) {
                alert('Error: ' + xhr.responseText);
            });

            if(totalPosts == total-1) {
                $('.more-btn').hide();
            }
    };

    $('.blog-section').on('click','.pagination a', function (e) {
        e.preventDefault();
        paginateBlog($(this).attr('href'));
    });
}

function formSubmit(form, area) {
    $(form).submit(function(e){
        e.preventDefault();
        area.animate({opacity : 0}, 500);
        $.ajax({
            type : "POST",
            url : $(this).attr('action'),
            data : $(this).serialize(),
            dataType : 'json',
            complete : function(data){
                var content;
                if (data && data.responseJSON && data.responseJSON.SuccessMessage) {
                    content = data.responseJSON.SuccessMessage;
                    if (typeof dataLayer != "undefined") {
                        dataLayer.push({
                            'event': 'formSubmitted',
                            'formName': 'Blog Signup'
                        });
                    }
                } else {
                    content = '<p class="success">Sorry there was an issue. Please try again shortly.</p>';
                }
                area.html(content).animate({opacity : 1}, 500);
            }
        });
    });
}

if($('#Form_BlogSignupForm').length > 0) {
    formSubmit($('#Form_BlogSignupForm'), $('.signup'));
}
if($('#Form_BlogSignupMobileForm').length > 0) {
    formSubmit($('#Form_BlogSignupMobileForm'), $('.mobile-signup'));
}


// WEBPACK FOOTER //
// ./themes/base/js/app.js